module.exports = __webpack_public_path__ + "static/media/icon_spinner_small.927a5b0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_spinner_small.svg
// module id = 251
// module chunks = 0